module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings":"Settings"}}')
  delete Component.options._Ctor
}
